import { QC_TASK_TABS } from '../constants/qcTaskDomainConstants';

/**
 * URL / search-param helpers specific to MT-QC-TASK-001 (tab + table filter keys).
 */

/**
 * Reads table filter fields from URL search params (deep-linking / shareable URLs).
 *
 * @param {URLSearchParams} searchParams
 * @returns {Record<string, string>} Filter keys aligned with `getAssignedRequests` query params.
 */
export function buildTableFiltersFromSearchParams(searchParams) {
  return {
    language: searchParams.get('language') ?? '',
    district: searchParams.get('district') ?? '',
    state: searchParams.get('state') ?? '',
    duration: searchParams.get('duration') ?? '',
    file_name: searchParams.get('file_name') ?? '',
    assigned_to: searchParams.get('assigned_to') ?? '',
    assigned_reviewer: searchParams.get('assigned_reviewer') ?? '',
    search: searchParams.get('search') ?? '',
  };
}

/**
 * Normalizes the `tab` query param to one of the supported tab keys.
 *
 * @param {string | null} raw - Value from `searchParams.get('tab')`.
 * @returns {keyof typeof QC_TASK_TABS}
 */
export function normalizeTabFromSearchParam(raw) {
  const tab = String(raw ?? QC_TASK_TABS.NEW).toUpperCase();
  if (
    tab === QC_TASK_TABS.NEW ||
    tab === QC_TASK_TABS.SAVE_FOR_LATER ||
    tab === QC_TASK_TABS.SUBMITTED
  ) {
    return tab;
  }
  return QC_TASK_TABS.NEW;
}
